"use strict";

const SettingsModalController = function () {
  const htmlPath = "modals/settingsModal";
  let $settingsModal;
  let props;

  function getParentPage() {
    return $settingsModal;
  }
  function isEsg() {
    return Tree.get("tool") === "esg";
  }

  function loadListeners(pages) {
    $settingsModal.off("click", ".leave-settings", closeModal);
    $settingsModal.on("click", ".leave-settings", closeModal);

    $settingsModal.off("click", ".settings-nav li", _setActivePageClick);
    $settingsModal.on("click", ".settings-nav li", _setActivePageClick);

    $(window).off("resize", _resizeWindow);
    $(window).on("resize", _resizeWindow);

    pages.forEach(function (page) {
      page.loadListeners();
    });
  }

  async function _setActivePageClick(e) {
    const proceed = await confirmAndResetIfUnsaved(getActiveMenu, checkActivePageHasUpdates);
    if (!proceed) return false;

    const pageToNav = $(this).attr("id");
    setMenuActive(pageToNav);
  }

  async function confirmAndResetIfUnsaved(getActiveMenu, checkActivePageHasUpdates) {
    if (checkActivePageHasUpdates()) {
      try {
        const activeMenu = getActiveMenu();
        if (activeMenu.confirmDiscardChanges) {
          await activeMenu.confirmDiscardChanges();
        }
        if (activeMenu.resetForm) {
          await activeMenu.resetForm();
        }
      } catch (e) {
        return false;
      }
    }
    return true;
  }

  function _resizeWindow() {
    if ($(window).width() < 1180) {
      closeModal();
    }
  }

  function canAccessSettings() {
    const menus = _getMenus();
    return menus.length > 0;
  }

  async function showSettingsModal() {
    $settingsModal = $("#settings-modal");
    const menus = _getMenus();
    if (menus.length === 0) {
      return;
    }
    const menuNav = getNavProps(menus);
    const menuProps = await getMenuProps(menus);
    props = menuProps;
    const html = nunjucks.render("modals/settingsModal/settingsModal.njk", {
      menus: menuNav,
      props: menuProps,
    });
    $settingsModal.html(html);
    setMenuActive(menuNav[0].menuKey);
    loadListeners(menus);
    $settingsModal.modal("show");
    menus[0].onShow();
  }

  function updateExistingProps(newProps) {
    props = newProps;
  }

  function getExistingProps() {
    return props;
  }

  function _getMenus() {
    const loadedMenus = [];
    const menus = [
      {
        model: UserManagement,
        permission: "can_manage_users",
      },
      {
        model: ApiKeyManagement,
        permission: "can_manage_api_keys",
        featureFlag: "public-api-keys",
        esg: false,
      },
      {
        model: EswftSyncManagement,
        permission: "can_manage_eswft_sync",
        esg: false,
      },
      {
        model: CustomEsriLayerManagement,
        require2nAdmin: true,
        esg: false,
      },
      {
        model: ConstructionModuleSettings,
        enabledTool: "construction",
        esg: false,
      },
      {
        model: LidModuleSettings,
        enabledTool: "lid",
        esg: false,
      },
      {
        model: IndcomModuleSettings,
        enabledTool: "indcom",
        esg: false,
      },
      {
        model: IddeModuleSettings,
        enabledTool: "idde",
        esg: false,
      },
    ];

    for (const index in menus) {
      const menuConfig = menus[index];
      if (menuConfig.permission && !UserPermissions.getPermission(menuConfig.permission)) {
        continue;
      }
      if (menuConfig.featureFlag && !FeatureFlag.enabled(menuConfig.featureFlag)) {
        continue;
      }
      if (isEsg() && menuConfig.esg === false) {
        continue;
      }
      if (menuConfig.require2nAdmin && !Session.is2nAdmin()) {
        continue;
      }
      if (menuConfig.enabledTool) {
        const groupTools = ToolFunctions.getToolsEnabledForGroup();
        if (!groupTools.includes(menuConfig.enabledTool) || !Session.isAdmin()) {
          continue;
        }
      }
      if (menuConfig.hidden) {
        continue;
      }

      loadedMenus.push(menuConfig.model);
    }

    return loadedMenus;
  }

  function getNavProps(menus) {
    return menus.map((menu) => ({
      menuOption: menu.getMenuOption(),
      menuIcon: menu.getMenuIcon(),
      menuKey: menu.getMenuKey(),
      menuPath: `${htmlPath}/${Misc.kebabToCamel(menu.getMenuKey())}.njk`,
    }));
  }

  async function getMenuProps(menus) {
    const menuPropsFunctions = menus.flatMap((menu) => menu.getProps());
    const props = await Promise.all(menuPropsFunctions).then((values) => values);
    const propsReduced = props.reduce((props, tab) => {
      return $.extend(true, props, tab);
    }, {});

    return propsReduced;
  }

  async function closeModal() {
    const proceed = await confirmAndResetIfUnsaved(getActiveMenu, checkActivePageHasUpdates);
    if (!proceed) return false;

    _getMenus().forEach((menu) => menu.onClose());
    $settingsModal.modal("hide");
    Analytics.clearFilterContext();
  }

  function setMenuActive(menuKey) {
    $settingsModal.find("li").toggleClass("active", false);
    $settingsModal.find(`li#${menuKey}`).toggleClass("active", true);
    $settingsModal.find(".modal-dynamic-content > *").toggleClass("hidden", true);
    $settingsModal.find(`.modal-dynamic-content #${menuKey}-page`).toggleClass("hidden", false);
    Analytics.sendSettingsEvent(`${menuKey}-page`);
  }

  function getActiveMenu() {
    return _getMenus().find((menu) => {
      const menuKey = menu.getMenuKey();
      return $settingsModal.find(`li#${menuKey}`).hasClass("active");
    });
  }

  function checkActivePageHasUpdates() {
    const activeMenu = getActiveMenu();
    if (activeMenu.noUpdatesInForm) {
      return !activeMenu.noUpdatesInForm();
    }

    return false;
  }

  return {
    canAccessSettings,
    showSettingsModal,
    getParentPage,
    getExistingProps,
    updateExistingProps,
    setMenuActive,
  };
};

module.exports = SettingsModalController();

const Analytics = require("../general/analytics");
const Misc = require("../misc");
const UserPermissions = require("../login/userPermissions");
const UserManagement = require("./settingsMenus/userManagement");
const ApiKeyManagement = require("./settingsMenus/apiKeyManagement");
const EswftSyncManagement = require("./settingsMenus/eswftSyncManagement");
const ConstructionModuleSettings = require("./moduleSettings/constructionModuleSettings");
const IddeModuleSettings = require("./moduleSettings/iddeModuleSettings");
const IndcomModuleSettings = require("./moduleSettings/indcomModuleSettings");
const LidModuleSettings = require("./moduleSettings/lidModuleSettings");
const CustomEsriLayerManagement = require("./settingsMenus/customEsriLayerManagement");
const FeatureFlag = require("./featureFlag");
const Tree = require("../tree");
const ToolFunctions = require("../toolFunctions");
const Session = require("../login/session");
